import { createContext } from 'react';

/**
 * @type {React.Context<string>}
 */
const PageTypeContext = createContext('career');

export default PageTypeContext;
